import { useMutation } from '@apollo/client';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_DRAFT_CATEGORIES_MUTATION } from '../../../graphql/resolvers/draftMutations/updateDraftCategories.gql';
import { GET_DRAFT_BY_ID } from '../../../graphql/resolvers/draftQueries/getDraftById.gql';
import { extractedCategories } from '../../../helpers/extractedCategories';
import type {
  AutoCompleteCategories,
  ChipData,
  DraftInterfaceState,
} from '../../../interfaces/post.interface';
import { draftSlice } from '../../../store/draft.store';
import './draft-categories.scss';

const DraftCategories = ({ draftId }: { draftId: string }) => {
  const dispatch = useDispatch();
  const { categories, refreshDraft } = useSelector(
    (state: DraftInterfaceState) => state.draftStore,
  );
  const { SAVE_DRAFT_CATEGORIES, REFRESH_DRAFT_STORE_ACTION } =
    draftSlice.actions;
  const [updatedCategories, setUpdatedCategories] =
    React.useState<boolean>(false);
  const [savedCategories, setSavedCategories] = React.useState<ChipData[]>();

  React.useEffect(() => {
    if (categories) {
      const categoriesArray = categories?.map((value, index) => ({
        key: index,
        label: value,
      }));
      setSavedCategories(categoriesArray as any[]);
    }
  }, [categories]);

  const handleDelete = (chipToDelete: ChipData) => () => {
    setSavedCategories((chips) =>
      chips?.filter((chip) => chip.key !== chipToDelete.key),
    );
    setUpdatedCategories(true);
  };

  React.useEffect(() => {
    if (updatedCategories) {
      if (savedCategories) {
        const payload = extractedCategories(
          savedCategories as AutoCompleteCategories[],
        );
        dispatch(SAVE_DRAFT_CATEGORIES(payload));

        updateDraftCategories({
          variables: { input: { categories: payload, id: draftId } },
        })
          .then((res) => {
            dispatch(REFRESH_DRAFT_STORE_ACTION(true));
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            dispatch(REFRESH_DRAFT_STORE_ACTION(false));
            setUpdatedCategories(false);
          });
      }
    }
  }, [updatedCategories, savedCategories]);

  const [updateDraftCategories, { data, loading, error }] = useMutation(
    UPDATE_DRAFT_CATEGORIES_MUTATION,
    {
      variables: {
        input: undefined,
      },
      refetchQueries: [{ query: GET_DRAFT_BY_ID, variables: { id: draftId } }],
      onError: (ex) => {
        console.error('useMutation error =>', ex);
      },
    },
  );

  const renderChips = savedCategories?.map((data) => {
    try {
      if (data) {
        return (
          <span key={data.key} className="chip">
            {data.label}
            <button type="button" onClick={handleDelete(data)}>
              ×
            </button>
          </span>
        );
      }
    } catch (ex) {
      console.error('Error loading categories, ex: ', ex);
    }
  });

  return (
    <div className="Stack">
      {loading ? (
        <div
          className="skeleton"
          aria-hidden="true"
          style={{ width: '100%', height: '20px' }}
        />
      ) : (
        renderChips
      )}
    </div>
  );
};

export default DraftCategories;
